import { connectedStore } from '../../store';
import removeResponsiveClassAction from '../actions/remove-responsive-class';
import { USED_ACTION_CREATOR } from '../constants/symbols';

const removeResponsiveClass = ({ elementId, className, breakpoint, options }) => {
  const store = connectedStore.get();
  store.dispatch(removeResponsiveClassAction({ elementId, className, breakpoint, options }));
};

removeResponsiveClass[USED_ACTION_CREATOR] = removeResponsiveClassAction;

export default removeResponsiveClass;
